import { Header } from "@/components/mad/Header";
import { Hero } from "@/components/mad/Hero";
import { Story } from "@/components/mad/Story";
import { ProductDetails } from "@/components/mad/ProductDetails";
import { Footer } from "@/components/mad/Footer";
import { Marquee } from "@/components/mad/Marquee";
import { Stats } from "@/components/mad/Stats";
import { Testimonials } from "@/components/mad/Testimonials";
import { ReserveCTA } from "@/components/mad/ReserveCTA";
import { Manifesto } from "@/components/mad/Manifesto";
import { Ritual } from "@/components/mad/Ritual";
import { FAQ } from "@/components/mad/FAQ";
import { ScrollProgress } from "@/components/mad/ScrollProgress";

export default function Landing() {
    return (
        <main
            data-testid="landing-page"
            lang="sk"
            className="relative min-h-screen bg-[#050505] text-[#F5F5F5] font-body overflow-x-hidden"
        >
            <ScrollProgress />
            <Header />
            <Hero />
            <Marquee />
            <Stats />
            <Story />
            <Manifesto />
            <ProductDetails />
            <Ritual />
            <Testimonials />
            <FAQ />
            <ReserveCTA />
            <Footer />
        </main>
    );
}
